import { render, staticRenderFns } from "./AudioUpload.vue?vue&type=template&id=f4bc4262&scoped=true&"
import script from "./AudioUpload.vue?vue&type=script&lang=js&"
export * from "./AudioUpload.vue?vue&type=script&lang=js&"
import style0 from "./AudioUpload.vue?vue&type=style&index=0&id=f4bc4262&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4bc4262",
  null
  
)

export default component.exports